import { ExpensesParams } from './Expenses.types';

export default class Expenses {
  nextAmount: string;
  nextDays: number;
  expenses?: StringOrNumber;

  constructor({ nextAmount, nextDays, expenses }: ExpensesParams) {
    this.nextAmount = nextAmount;
    this.nextDays = nextDays;
    this.expenses = expenses;
  }
}
